import { Navigate } from "react-router-dom";
import { useContext } from "react";
import UserContext from "../Context/user.context";
import { ROUTES } from "../constants/routes";

export default function PublicRoute({ children }) {
  const { isAuthanticate, loading } = useContext(UserContext);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (isAuthanticate) return <Navigate to={ROUTES.HOME} replace />;
  return children;
}
